<template>
  <MainDialog :persistent="false" :show="show" :on-close="onClose">
    <v-card>
      <v-card-title>Add Picanova Fulfillment</v-card-title>
      <v-card-text>
        <div v-if="errorMessage">ERROR: {{ errorMessage }}</div>
        <v-text-field v-model="picanovaId" label="Picanova Id (PPOXXXXXXXX)" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="isAddingFulfillment" :loading="isAddingFulfillment" @click="addPicanovaFulfillment">Add Fulfillment</v-btn>
      </v-card-actions>
    </v-card>
  </MainDialog>
</template>

<script>
import MainDialog from "@/components/MainDialog";
import {httpsCallable} from "firebase/functions";
import {functions} from "../../../../fb";
export default {
  name: "ResolvePicanovaErrorDialog",
  components: { MainDialog },
  data() {
    return {
      picanovaId: "",
      isAddingFulfillment: false,
      error: false,
      errorMessage: "",
    }
  },
  props: {
    show: {
      type: Boolean,
      require: true,
    },
    onClose: {
      required: false,
    },
    orderId: {
      type: String,
      required: true
    }
  },
  methods: {
    async addPicanovaFulfillment() {
      this.isAddingFulfillment = true
      const addFulfillment = httpsCallable(functions, "addPicanovaFulfillment");
      try {
        await addFulfillment({
          orderId: this.orderId,
          picanovaId: this.picanovaId
        });
      } catch (e) {
        this.error = true;
        this.errorMessage = e.message
      }
      this.isAddingFulfillment = false
      this.onClose()
    }
  }
};
</script>

<style scoped></style>
